export const MAIN_PWA_IDENTIFIER = 'lu_main_pwa'; // Should be same as in manifest.json
export const ANROID_AND_IOS_APP_SOURCE = 'app_webview';
export const MAIN_APP_IDENTIFIER = 'lu_main_app';

/** Own cookie with the params captured from the URL. Also read by the GA config hook. */
export const TRACKING_USER_PARAMS_COOKIE = 'tracking-user-params';

/** Campaign params — a registered browser may still send these; everything else is gated. */
export const MARKETING_TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
];

/** Affiliate attribution — `stag` holds affiliateID_visitorID. Gated for registered browsers. */
export const STAG_PARAM = 'stag';
export const AFFILIATE_TRACKING_PARAMS = [STAG_PARAM, 'ref_code'];

/** Everything we capture from the URL and forward to SS `/info/project`. */
export const USER_TRACKING_PARAMS_SS = [
  ...AFFILIATE_TRACKING_PARAMS,
  ...MARKETING_TRACKING_PARAMS,
];

/**
 * Campaign cookies SS writes on our domain. Names do not all mirror the URL params:
 * `referral_params` holds the whole payload zlib+base64 encoded.
 * SS lifecycle: the `stag` cookie lives only until registration, then SS drops it and
 * writes `trackers` instead — a signed-out registered browser never has `stag`.
 */
export const SS_MARKETING_COOKIES = [
  ...MARKETING_TRACKING_PARAMS,
  'trackers',
  'referral_params',
];
